"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSessionTime = exports.renderAttendanceDuration = exports.isAttendanceAvailable = exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _DataTable = require("../../components/DataTable");
var _utils = require("../../utils");
var _classnames = _interopRequireDefault(require("classnames"));
require("./PatientGroupsList.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Paragraph = _typography.default.Paragraph;
var renderSessionTime = function renderSessionTime(startAt) {
  return (0, _utils.formatDate)(startAt, {
    timeFormat: 'h:mm A, z',
    withTime: true
  });
};
exports.renderSessionTime = renderSessionTime;
var renderAttendanceDuration = function renderAttendanceDuration(attendance) {
  var createdAt = (0, _momentTimezone.default)(attendance.createdAt);
  var updatedAt = (0, _momentTimezone.default)(attendance.updatedAt);
  var minutes = updatedAt.diff(createdAt, 'minutes');
  return "".concat(minutes, " minutes");
};

// We began recording group session attendance on May 21 at 3pm EDT. Attendance data for sessions
// before this date should be displayed as N/A. Technically the backend should be the source of
// truth on this, but felt like overkill to handle such a small thing on both sides.
exports.renderAttendanceDuration = renderAttendanceDuration;
var GROUP_ATTENDANCE_START_DATE = (0, _momentTimezone.default)('2020-05-21T19:00:00Z');
var isAttendanceAvailable = function isAttendanceAvailable(session) {
  return (0, _momentTimezone.default)(session.startAt) > GROUP_ATTENDANCE_START_DATE;
};
exports.isAttendanceAvailable = isAttendanceAvailable;
var PatientGroupsList = function PatientGroupsList(_ref) {
  var patientId = _ref.patientId,
    className = _ref.className;
  var _useFetch = (0, _utils.useFetch)((0, _utils.getGroupSessionParticipationForPatientUrl)(patientId), [], !!patientId),
    participations = _useFetch.data,
    loading = _useFetch.loading;
  var columns = [{
    title: 'Group',
    dataIndex: 'group',
    sorter: function sorter(a, b) {
      return a.group.name.localeCompare(b.group.name);
    },
    render: function render(group) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: "/groups/".concat(group.id, "/sessions")
      }, group.name);
    }
  }, {
    title: 'Session',
    dataIndex: 'groupSession',
    sorter: function sorter(a, b) {
      return (0, _momentTimezone.default)(a.groupSession.startAt) - (0, _momentTimezone.default)(b.groupSession.startAt);
    },
    defaultSortOrder: 'descend',
    render: function render(groupSession) {
      return renderSessionTime(groupSession.startAt);
    }
  }, {
    title: 'RSVP',
    dataIndex: 'rsvp',
    align: 'center',
    className: 'icon-column',
    render: function render(rsvp) {
      return rsvp ? /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "check-square",
        theme: "filled",
        className: "icon-green"
      }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "close-square",
        className: "icon-default"
      });
    }
  }, {
    title: 'Attendance',
    key: 'attendance',
    align: 'center',
    className: 'icon-column',
    render: function render(_ref2) {
      var groupSession = _ref2.groupSession,
        attendance = _ref2.attendance;
      return isAttendanceAvailable(groupSession) ? attendance ? renderAttendanceDuration(attendance) : /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "close-square",
        className: "icon-default"
      }) : 'N/A';
    }
  }];
  var rsvpCount = (0, _react.useMemo)(function () {
    return participations.filter(function (_ref3) {
      var rsvp = _ref3.rsvp;
      return !!rsvp;
    }).length;
  }, [participations]);
  var attendanceCount = (0, _react.useMemo)(function () {
    return participations.filter(function (_ref4) {
      var attendance = _ref4.attendance;
      return !!attendance;
    }).length;
  }, [participations]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('patient-groups-list', className)
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading
  }, /*#__PURE__*/_react.default.createElement(Paragraph, {
    type: "secondary"
  }, rsvpCount, " rsvps / ", attendanceCount, " attendances"), /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, {
    columns: columns,
    rowKey: function rowKey(_ref5) {
      var groupSession = _ref5.groupSession;
      return groupSession.id;
    },
    dataSource: participations,
    pagination: false
  })));
};
var _default = PatientGroupsList;
exports.default = _default;